/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ResourcePoolProviderType } from './resourcePoolProviderType';


export interface SddcDetailsResponse { 
    /**
     * SDDC ID
     */
    sddc_id?: string;
    provider_type?: ResourcePoolProviderType;
    /**
     * Provider ID
     */
    provider_id?: string;
    /**
     * Region
     */
    region?: string;
    /**
     * Assigned org ids
     */
    org_id?: Array<string>;
    /**
     * SDDC state
     */
    state?: string;
    /**
     * Host count
     */
    host_count?: number;
    /**
     * Instance types
     */
    instance_types?: object;
    /**
     * Billing status
     */
    billing_status?: string;
    /**
     * Metadata
     */
    metadata?: object;
}
export namespace SddcDetailsResponse {
}


